export default "__VITE_ASSET__CncqMakA__"